import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import AlertRuleCreateOrUpdateSF from '../../components/projectapp/alertRule/AlertRuleCreateOrUpdateSF'

const AlertRuleUpdatePageUI = ({context, project, alertRule, messageList}) =>
  <PrivatePageSF context={context} className='pg_alrt_upd'
    backLink={project ? `/projects/${project.projectId}/alerts` : ''}
    messageList={messageList} headerMessageKey='c_alert_rule'
    subHeaderText={`${project ? project.projectName : ''}`}
  >
    <PageTitleUI context={context} goBack={true}
      backLink={project ? `/projects/${project.projectId}/alerts` : ''}
      messageList={messageList} titleMessageKey='c_alert_rule'
      subTitleText={`${project ? project.projectName : ''}`}
    />

    {
      !alertRule &&
      <SpinnerComponentUI />
    }
    {
      alertRule &&
      <React.Fragment>
        <AlertRuleCreateOrUpdateSF context={context} messageList={messageList} project={project} alertRule={alertRule} />
      </React.Fragment>
    }
  </PrivatePageSF>

export default AlertRuleUpdatePageUI
